import Img from './settings.png';
import './Settings.css';

const Settings = () => {
    return (
        <img className='img-settings' src={Img} alt="" />
    );
}

export default Settings;
